import { CustomizationType } from '../types/EcomSDK';

export interface OptionType {
    label?: string;
    value: string | number;
    disabled?: boolean;
}

export interface OptionsVariationsType {
    [option: string]: Array<OptionType>;
}

export interface ProductType {
    identifier: string;
    sku: string;
    price: number;
    displayed_price: string;
    displayed_compare_at?: string;
    images: Image[];
    name: string;
    description: string;
    options: OptionsVariationsType;
    variations: VariationType[];
    customizations: Customization[];
    image: string;
    additional_image: string;
    link_text: string;
    seo_title: string;
    seo_description: string;
    internal_quantity?: number;
    external_id?: string;
    shippable?: boolean;
    purchase_options?: ProductPurchaseOptionType[];
    payment_plans?: ProductPaymentPlan[];
    is_tax_included?: boolean;
    tax_percentage?: number;
}

export interface ProductViewType extends Omit<ProductType, 'options'> {
    options: Array<{
        choices: string; // comma separated values
        name: string;
    }>;
}
export enum ProductPurchaseOptionType {
    ONE_TIME = 'ONE_TIME',
    SUBSCRIPTION = 'SUBSCRIPTION',
}

export interface ProductPaymentPlan {
    id: string;
    name: string;
    tag_line?: string;
    discount_percentage?: number;
    frequency?: ProductPaymentFrequency;
    interval?: number;
    expiration_count?: number;
    plan_price: number;
    plan_displayed_price: string;
    tax_percentage?: number | null;
}

export enum ProductPaymentFrequency {
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}

export interface VariationType
    extends Pick<
        ProductType,
        | 'identifier'
        | 'price'
        | 'displayed_price'
        | 'images'
        | 'sku'
        | 'internal_quantity'
        | 'external_id'
        | 'tax_percentage'
    > {
    selected_options_values: string;
    plans_prices: Array<{
        id: string;
        price: number;
        displayed_price: string;
    }>;
    lowest_prices?: LowestPriceType[] | [];
}

// Merges product & current variation data
export type ProductEntity = ProductType &
    Partial<VariationType> & { itemId: string; productId: string };

interface Image {
    alt_text: string;
    image: string;
}

export interface LowestPriceType {
    plan_id: string | null;
    displayed_price: string;
    period: number;
}

export interface CheckboxChoice {
    identifier: string;
    label: string;
}

export interface CheckboxLimitations {
    min_choices?: number | null;
    max_choices?: number | null;
}

export interface Customization {
    id: string;
    label: string;
    title: string;
    mandatory: boolean;
    type: CustomizationType;

    // TEXT
    hint?: string;

    // CHECKBOX
    choices?: CheckboxChoice[];
    limitations?: CheckboxLimitations;
}

export type CustomizationValue = string | string[] | undefined;
